export const products = [
  {
    id: 1,
    name: "Zari Embroidered Lehenga",
    category: "Bridal",
    price: 12500,
    originalPrice: 15000,
    image: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=600&q=80",
    tag: "Bestseller",
    description: "Hand-crafted zari work on premium silk. Perfect for weddings and grand occasions.",
    colors: ["#8B0000", "#1a0a00", "#C4726A"],
    sizes: ["XS", "S", "M", "L", "XL"]
  },
  {
    id: 2,
    name: "Chanderi Anarkali Suit",
    category: "Festive",
    price: 4800,
    originalPrice: 6000,
    image: "https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=600&q=80",
    tag: "New",
    description: "Light chanderi fabric with delicate block prints. Elegant for festive gatherings.",
    colors: ["#C9A84C", "#4a7c59", "#6b4fbb"],
    sizes: ["S", "M", "L", "XL"]
  },
  {
    id: 3,
    name: "Banarasi Silk Saree",
    category: "Sarees",
    price: 8900,
    originalPrice: 10500,
    image: "https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?w=600&q=80",
    tag: "Premium",
    description: "Authentic Banarasi weave with golden border. A timeless heirloom piece.",
    colors: ["#722F37", "#1B4D3E", "#1a0a00"],
    sizes: ["Free Size"]
  },
  {
    id: 4,
    name: "Organza Sharara Set",
    category: "Party Wear",
    price: 5600,
    originalPrice: 7000,
    image: "https://images.unsplash.com/photo-1594938298603-c8148c4b4d8c?w=600&q=80",
    tag: "Trending",
    description: "Flowy organza sharara with mirror work blouse. Statement party wear.",
    colors: ["#D4AF8B", "#E8A0A0", "#87CEEB"],
    sizes: ["XS", "S", "M", "L"]
  },
  {
    id: 5,
    name: "Kanjivaram Silk Saree",
    category: "Sarees",
    price: 14200,
    originalPrice: 17000,
    image: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=600&q=80",
    tag: "Exclusive",
    description: "Pure Kanjivaram silk with temple border. South Indian craftsmanship at its finest.",
    colors: ["#800020", "#006400", "#4B0082"],
    sizes: ["Free Size"]
  },
  {
    id: 6,
    name: "Pastel Palazzo Kurta",
    category: "Casual",
    price: 2200,
    originalPrice: 2800,
    image: "https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=600&q=80",
    tag: "Summer Pick",
    description: "Breezy cotton kurta with palazzo pants. Perfect for everyday elegance.",
    colors: ["#E8D5B7", "#B8D8D8", "#F4C2C2"],
    sizes: ["XS", "S", "M", "L", "XL", "XXL"]
  },
  {
    id: 7,
    name: "Velvet Bridal Blouse",
    category: "Bridal",
    price: 3500,
    originalPrice: 4200,
    image: "https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?w=600&q=80",
    tag: "Bridal",
    description: "Heavily embellished velvet blouse with stone work. Designed for the modern bride.",
    colors: ["#722F37", "#1a0a00", "#2C3E7A"],
    sizes: ["XS", "S", "M", "L", "XL"]
  },
  {
    id: 8,
    name: "Embroidered Dupatta Set",
    category: "Festive",
    price: 3800,
    originalPrice: 4500,
    image: "https://images.unsplash.com/photo-1594938298603-c8148c4b4d8c?w=600&q=80",
    tag: "Gift Ready",
    description: "Phulkari embroidered dupatta set with matching salwar. Festive and vibrant.",
    colors: ["#FF6B6B", "#FFD700", "#98FB98"],
    sizes: ["S", "M", "L"]
  }
];

export const categories = ["All", "Bridal", "Sarees", "Festive", "Party Wear", "Casual"];
